define("DC.Confirmation.View", [
  "dc_confirmation_view.tpl",
  "ProductLine.Sku.View",
  "Cart.AddToCart.Button.View",
  "Product.Model",
  "SC.Configuration",
  "Utils",
  "Backbone",
], function (
  dc_confirmation_view_tpl,
  ProductLineSkuView,
  CartAddToCartButtonView,
  ProductModel,
  Configuration,
  Utils,
  Backbone
) {
  "use strict";

  // @class DC.QuantityPricing.QtyPrice.View @extends Backbone.View
  return Backbone.View.extend({
    template: dc_confirmation_view_tpl,

    modalClass: "global-views-modal-large",

    initialize: function (options) {
      console.log("=== CONFIRMATION VIEW INIT ===");
      console.log("options received:", options);
      console.log("options.selectedIndex:", options.selectedIndex);

      this.container = options.container;
      this.item = options.model.get("item");
      this.model = options.model;
      this.selectedIndex = options.selectedIndex;
    },

    // @property {Object} childViews
    childViews: {
      "Line.Sku": function () {
        return new ProductLineSkuView({
          model: this.model,
        });
      },

      AddToCart: function () {
        var selectedPrice = this.getSelectedPrice();
        var product = new ProductModel({
          item: this.model.getItem(),
          quantity: selectedPrice.minimumquantity,
        });

        this.model.set("quantity", selectedPrice.minimumquantity);
        product.set("options", this.model.get("options"));

        return new CartAddToCartButtonView({
          // model: this.item.get('_matrixChilds').length > 0 ? this.item : product,
          model: product,
          application: this.container,
          showButton: true,
        });
      },
    },

    // getSelectedPrice: function () {
    //   var priceSchedule =
    //     this.model &&
    //     this.model.get("item") &&
    //     this.model.get("item").get("onlinecustomerprice_detail")
    //       ? this.model.get("item").get("onlinecustomerprice_detail")
    //           .priceschedule
    //       : [];

    //   var self = this;
    //   _.map(priceSchedule, function (price, index) {
    //     var freightMessage = self.model
    //       .get("item")
    //       .get("custitem_bags_freight" + (index + 1))
    //       ? " (+FRT)"
    //       : ""; //as index starts from 0
    //     price.price_formatted =
    //       "$" +
    //       (price.price * price.minimumquantity).toFixed(2) +
    //       freightMessage;
    //     return price;
    //   });

    //   if (priceSchedule) {
    //     console.log(
    //       "priceSchedule[this.selectedIndex]",
    //       priceSchedule[this.model.get("selectedIndex")]
    //     );
    //     return priceSchedule[this.selectedIndex];
    //   }
    //   return {};
    // },

    getSelectedPrice: function () {
        var baseTiersString = this.model.get("item").get("custitem_base_price_tiers");
        var saleTiersString = this.model.get("item").get("custitem_sale_price_tiers");
        
        // Reuse the same parse/build logic or pass combinedPriceSchedule via options
        var priceSchedule = this.model.get("combinedPriceSchedule");
        
        if (priceSchedule && priceSchedule[this.selectedIndex]) {
            return priceSchedule[this.selectedIndex];
        }
        return {};
    },
    hasRequiredCustomFields: function () {
      var hasRequiredFields = true;

      console.log("this.model.getItem()", this.model.getItem());
      if (
        this.model.getItem().get("_optionsDetails") &&
        this.model.getItem().get("_optionsDetails").fields
      ) {
        _.find(
          this.model.getItem().get("_optionsDetails").fields,
          function (field) {
            if (field.ismandatory) {
              hasRequiredFields = true;
              return;
            }
          }
        );
      }
      return hasRequiredFields;
    },

    //@method getContext @return DC.QuantityPricing.QtyPrice.View.Context
    getContext: function getContext() {
      var item = this.model.get("item");
      // console.log('item in DC View', item);
      // console.log('Store Description', item.storedescripton);
      // console.log('Store Description', item.displayname);
      // console.log('Store Description', item._name);
      //  console.log('Store Description', item.get('storedescription'));

      console.log("=== CONFIRMATION VIEW getContext ===");
      console.log("this.model:", this.model);
      console.log("combinedPriceSchedule from model:", this.model.get("combinedPriceSchedule"));
      console.log("this.selectedIndex:", this.selectedIndex);

      var selectedPrice = this.getSelectedPrice();

      console.log("=== Confirmation getContext DEBUG ===");
      console.log("selectedPrice:", JSON.stringify(selectedPrice));
      console.log("hasFreight:", selectedPrice.hasFreight);
      console.log("hasSalePrice:", selectedPrice.hasSalePrice);
      console.log("price_formatted:", selectedPrice.price_formatted);
      console.log("base_price_formatted:", selectedPrice.base_price_formatted);

      this.showQuickAddToCartButton = !!(
        Configuration.get("addToCartFromFacetsView", false) &&
        this.model.getItem().get("_isPurchasable") &&
        this.model.areAttributesValid(["options"])
      );

      //Log showQuickAddToCartButton
      console.log("showQuickAddToCartButton:", this.showQuickAddToCartButton);
      console.log(
        "this.this.model.areAttributesValid(['options'])():",
        this.model.areAttributesValid(["options"])
      );

      return {
        // @property {LiveOrder.Line.Model} model
        model: this.model,

        showQuickAddToCartButton: this.showQuickAddToCartButton,
        // @property {ImageContainer} thumbnail
        thumbnail: this.model.getThumbnail(),

        showQuantity: !_.isEmpty(selectedPrice),

        quantity:
          selectedPrice && selectedPrice.minimumquantity
            ? selectedPrice.minimumquantity
            : 0,

        // amount:
        //   selectedPrice && selectedPrice.price_formatted
        //     ? selectedPrice.price_formatted
        //     : "",
        amount:
          selectedPrice && selectedPrice.price_formatted
              ? selectedPrice.price_formatted + (selectedPrice.hasFreight && selectedPrice.hasSalePrice ? " (+FRT)" : "")
              : "",
        // @property {String} itemName
        itemName: item.get("storedescription"),

        itemOptionErr: this.model.areAttributesValid(["options"])
          ? false
          : true,
      };
    },
  });
});
